export const tryParseFloat = (value: string) => {
  try {
    return parseFloat(value);
  } catch {
    return null;
  }
};
